// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PlayIcon_wrapper_22ssY","icon":"PlayIcon_icon_2KXe-","isDisabled":"PlayIcon_isDisabled_2ZuQ5"};